import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://eeb3e57b5ff0404eb372264d0270fc8e@sentry.io/5187592',
  });
}

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
